import { useWindowSize } from "./useWindowSize";

export const useBreakPointsValues = (sm, md, lg, options = { left: 768, right: 1200 }) => {
  const { width } = useWindowSize();

  if (width < options.left) return sm;
  if (width >= options.left && width < options.right) return md;
  return lg;
};
